export const DEFAULT_CACHE_TIME_MS = 1000 * 60 * 2;
export const DEFAULT_STALE_TIME_MS = 1000 * 60 * 1;
